import { ChainId, WETH9 } from '@pancakeswap/sdk'
import { USDC, USDT, WBTC_ETH } from '@pancakeswap/tokens'

export const goerliBaseTokens = {
  weth: WETH9[ChainId.GOERLI_BASE],
}
